const InfoPago = ({ pago }) => {
  console.log(pago);
  return (
      <ul className=" list-group info-pago" dangerouslySetInnerHTML={{__html: pago.historia}}></ul>
  );
};

export default InfoPago
